// extracted by mini-css-extract-plugin
module.exports = {"list":"Social_tiles_list__16fBr","bg":"Social_tiles_bg__24tNr"};